"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationStatusBadgeWrapper = void 0;
var react_1 = require("@emotion/react");
var styled_1 = __importDefault(require("@emotion/styled"));
exports.ApplicationStatusBadgeWrapper = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme, text = _a.text;
    return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    ", "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 8.6rem;\n    height: 2.8rem;\n    border-radius: 0.8rem;\n    cursor: default;\n  "], ["\n    ", "\n    ", "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 8.6rem;\n    height: 2.8rem;\n    border-radius: 0.8rem;\n    cursor: default;\n  "])), theme.fonts.medium13, theme.badge[text]);
});
var templateObject_1, templateObject_2;
